export class AppConfig {
    pop: string = '';
}